var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('b-card-title',[_vm._v("Bio")]),(_vm.userData.bio)?_c('p',[_vm._v(" "+_vm._s(_vm.userData.bio)+" ")]):_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("No bio details ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }